import Address from './Models/Address'
import Postcode from './Models/Postcode'

Vue.prototype.$models.$address = new Vue(Address)
Vue.prototype.$models.$postcode = new Vue(Postcode)

Vue.component('addresses-table', () => import(/* webpackChunkName: "addresses-table" */ '@modulesPages/Address/Resources/assets/js/Tables/AddressesTable'))

Vue.component('addresses-form', () => import(/* webpackChunkName: "addresses-form" */ '@modulesPages/Address/Resources/assets/js/Forms/Addresses/AddressesForm'))

Vue.component('google-autocomplete-component', () => import(/* webpackChunkName: "google-autocomplete-component" */ '@modulesPages/Address/Resources/assets/js/Components/GoogleAutocompleteComponent'))
Vue.component('resource-postcoder', () => import(/* webpackChunkName: "resource-postcoder" */ '@modulesPages/Address/Resources/assets/js/Components/ResourcePostcoder'))



app.$Util.formattedClassName = {
	...app.$Util.formattedClassName,
	...{
		'Modules\\Address\\Entities\\Address': 'Domicilio',
		'Modules\\Address\\Entities\\Postcode': 'Código Postal',
	}	
}

app.$Util.tableNameByClassName = {
	...app.$Util.tableNameByClassName,
	...{
		'Modules\\Address\\Entities\\Address': 'addresses',
		'Modules\\Address\\Entities\\Postcode': 'postcodes',
	}	
}

app.$Util.classNameByTableName = {
	...app.$Util.classNameByTableName,
	...{
		'addresses': 'Modules\\Address\\Entities\\Address',
		'postcodes': 'Modules\\Address\\Entities\\Postcode',
	}	
}

app.$Util.getFormattedAddress = function(address, type = 'a') {
	let address_string = ' '

	switch(type) {
		case 'a':
			address_string = `${address.street} #${address.number}, ${address.city_name} ${address.state_name} ${address.country_name}`
        break
	}

	return address_string
}